import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, useField } from 'react-final-form';

import { FormFlex, FormBox, FormGroupAdapter, SelectStateAdapter, HideComponentsButton, ShowComponentsButton } from 'components/shared/form';

import { getName, validateRequired } from 'utils';

const propTypes = {
  areComponentsRendered: PropTypes.bool.isRequired,
  setAreComponentsRendered: PropTypes.func.isRequired,
  namespace: PropTypes.string,
  refs: PropTypes.shape({
    statesCollection: PropTypes.arrayOf(PropTypes.object),
    countriesCollection: PropTypes.arrayOf(PropTypes.object),
  }),
  isRequired: PropTypes.bool,
  isFormDisabled: PropTypes.bool,
};

const defaultProps = {
  namespace: null,
  refs: {
    statesCollection: [],
    countriesCollection: [],
  },
  isRequired: true,
  isFormDisabled: false,
};

function AddressFieldsStep4({ isFormDisabled, namespace, refs, areComponentsRendered, setAreComponentsRendered, isRequired }) {
  if (!areComponentsRendered) {
    return (
      <Fragment>
        <FormFlex>
          <ShowComponentsButton
            setAreComponentsRendered={setAreComponentsRendered}
            namespace={namespace}
            isRequired={isRequired}
            countryCodeFieldName={getName(namespace, 'countryCode')}
          />
        </FormFlex>
      </Fragment>
    );
  }

  const {
    input: { value: countryCode },
  } = useField(getName(namespace, 'countryCode'));

  return (
    <Fragment>
      <FormFlex>
        <HideComponentsButton
          namespace={namespace}
          setAreComponentsRendered={setAreComponentsRendered}
          isRequired={isRequired}
          countryCodeFieldName={getName(namespace, 'countryCode')}
        />
      </FormFlex>
      <FormFlex>
        <FormBox width={[1, 1, 1 / 3]}>
          <Field
            name={getName(namespace, 'streetNumber')}
            required={isRequired}
            label="Street Number"
            disabled={isFormDisabled}
            validate={isRequired && validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <Field
            name={getName(namespace, 'streetName')}
            required={isRequired}
            label="Street Name"
            disabled={isFormDisabled}
            validate={isRequired && validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <Field
            name={getName(namespace, 'premise')}
            disabled={isFormDisabled}
            label="Unit/Apt #"
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={[1, 1, 1 / 3]}>
          <Field
            name={getName(namespace, 'municipality')}
            required={isRequired}
            label="City"
            disabled={isFormDisabled}
            validate={isRequired && validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <Field
            name={getName(namespace, 'postalCode')}
            required={isRequired}
            label="ZIP"
            disabled={isFormDisabled}
            validate={isRequired && validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          <Field
            name={getName(namespace, 'county')}
            disabled={isFormDisabled}
            label="County"
            component={FormGroupAdapter}
          />
        </FormBox>
      </FormFlex>
      <FormFlex>
        <FormBox width={[1, 1, 2 / 3]}>
          <Field
            name={getName(namespace, 'countryCode')}
            type="select"
            options={refs.countriesCollection}
            required={isRequired}
            isDisabled={isFormDisabled}
            label="Country"
            validate={isRequired && validateRequired()}
            component={FormGroupAdapter}
          />
        </FormBox>
        <FormBox width={[1, 1, 1 / 3]}>
          {countryCode === 'US' ?
            <Field
              name={getName(namespace, 'stateCode')}
              namespace={namespace}
              required={isRequired}
              type="select"
              isDisabled={isFormDisabled}
              options={refs.statesCollection}
              label="State"
              validate={isRequired && validateRequired()}
              component={SelectStateAdapter}
            />
            :
            <Field
              name={getName(namespace, 'province')}
              required={isRequired}
              label="Province"
              disabled={isFormDisabled}
              component={FormGroupAdapter}
              isConditional
            />}
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

AddressFieldsStep4.propTypes = propTypes;
AddressFieldsStep4.defaultProps = defaultProps;

export default AddressFieldsStep4;
